/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_BIG_spineliner': {
    width: 60,
    height: 62,
    viewBox: '0 0 60 62',
    data: '<path pid="0" d="M57 1c-16 32 13.5 26-3 60M32.5 46.5a4 4 0 1 1 0-8m1-3.419a8.003 8.003 0 0 1 0 14.837M35.5 31c4.105 1.84 7 6.295 7 11.5s-2.895 9.66-7 11.5M52 3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-3 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-1 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm2 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm1 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-1 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm-3 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM5.5 40.5h18a2 2 0 1 1 0 4c-18 0-13 4-22 4 1.008-1.429 4-5.143 4-8z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_BIG_spineliner.js